'use client';
import { createContext, ReactNode } from 'react';
import { Dictionary } from '@/types';

// Context for dictionary
export const DictionaryContext = createContext<Dictionary | null>(null);

// Provider component to wrap your app/pages
export function DictionaryProvider({
  children,
  dictionary,
}: {
  children: ReactNode;
  dictionary: Dictionary;
}) {
  return (
    <DictionaryContext.Provider value={dictionary}>
      {children}
    </DictionaryContext.Provider>
  );
}
